export default __webpack_public_path__ + "static/media/orion.e41b6e75.jpg";